import { SopType } from '@/graphql/generated/schemas'
import { OptionI } from '@/utils/forms/optionBuilders'

export const SOP_ROLES: OptionI<SopType>[] = [
  { label: 'Guard', value: SopType.Guard },
  { label: 'Operator', value: SopType.Operator },
]
